import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';

export const TitleText = styled.div`
  margin-top: ${gridSize()}px;
  margin-bottom: 16px;
`;

export const LoginLinkWrapper = styled.div<{ addTopMargin: boolean }>`
  margin-top: ${({ addTopMargin }) => (addTopMargin ? `${gridSize()}px` : 'initial')};
`;
